var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.68623 1.64634C8.9506 1.35799 9.39867 1.33855 9.68702 1.60291L24.8477 15.5025C25.7123 16.3023 25.724 17.6917 24.8434 18.4873C24.8424 18.4882 24.8415 18.489 24.8405 18.4899L9.68728 32.3969C9.39907 32.6614 8.95099 32.6422 8.68647 32.354C8.42195 32.0658 8.44117 31.6177 8.72939 31.3532L23.8928 17.4368C24.1423 17.2122 24.1534 16.7911 23.8865 16.5433C23.8862 16.543 23.8868 16.5435 23.8865 16.5433L8.72965 2.64713C8.4413 2.38277 8.42186 1.9347 8.68623 1.64634Z",
    fill: "#EF233C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFront);
export default __webpack_public_path__ + "static/media/arrow-front.8d2fe7b6afe3057dc71f469e3dca8853.svg";
export { ForwardRef as ReactComponent };